import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, Fade, makeStyles } from '@material-ui/core';
import Tooltip from '../tooltip';
import { ReactComponent as PlansIcon } from '../../../assets/icons/assignment_darker.svg';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    cursor: 'default',
    width: 18,
    height: 18,
  },
  iconSpacing: {
    marginRight: spacing(1),
  },
  plans: {
    marginBottom: spacing(-0.5),
  },
}));

const PlansIconTooltip = ({
  className = undefined,
  iconClass = undefined,
  text,
  numberOfPlans = 0,
  isVisible = false,
}) => {
  const classes = useStyles();
  const hasPlans = numberOfPlans !== 0;

  return (
    <Fade
      className={classNames(classes.root, className)}
      in={isVisible}
      unmountOnExit
    >
      <div className={classes.root}>
        <Tooltip
          customIconClass={classNames(
            classes.icon,
            {
              [classes.iconSpacing]: hasPlans,
            },
            iconClass
          )}
          text={text}
          icon={PlansIcon}
        />
        {hasPlans && (
          <Typography variant="subtitle2" className={classes.plans}>
            {numberOfPlans}
          </Typography>
        )}
      </div>
    </Fade>
  );
};

PlansIconTooltip.propTypes = {
  className: PropTypes.string,
  iconClass: PropTypes.string,
  text: PropTypes.string.isRequired,
  numberOfPlans: PropTypes.number,
  isVisible: PropTypes.bool,
};

export default PlansIconTooltip;
